
import { motion } from 'framer-motion';
import AnimatedActionButton from '../AnimatedActionButton';

const WhoAreWeSection = () => {
  return (
    <motion.section
      className="w-full py-16 font-sans"
      initial={{ opacity: 0, x: -60 }}
      whileInView={{ opacity: 1, x: 0 }}
      viewport={{ once: true, amount: 0.4 }}
      transition={{ duration: 0.8, ease: 'easeOut' }}
    >
      <div className="max-w-6xl mx-auto px-6 md:px-12 w-full">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-10 w-full gap-6">
          <h2 className="text-5xl md:text-6xl font-bold text-black" style={{ fontFamily: 'Inter, sans-serif' }}>
            Who are we 
          </h2>
          <AnimatedActionButton
            text="Read More"
            as="a"
            href="#"
            className="text-lg ml-0 md:ml-auto"
          />
        </div>
        <p className="text-xl text-black text-justify" style={{ fontFamily: 'Inter, sans-serif' }}>
          Lincoln AIM is a global technology recruitment firm specializing in high-impact hiring across the UK, US, and MENA regions. We partner with startups, hedge funds, and leading tech companies to deliver elite talent fast. Our approach is precise, honest, and built to drive long-term success for our clients and candidates.
        </p>
      </div>
    </motion.section>
  );
};

export default WhoAreWeSection; 